import React from "react"
import { Box } from "@mui/material"
import {
	Create,
	required,
	SimpleForm,
	TextInput,
	useNotify,
	useRedirect,
	useRefresh
} from "react-admin"

import sx from "utils/sx"

const JobCreate = () => {
	const notify = useNotify()
	const refresh = useRefresh()
	const redirect = useRedirect()

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onSuccess = (data: any) => {
		notify(
			"resources.jobs.notifications.create",
			{
				type: "info",
				messageArgs: { name: data.name }
			}
		)
		redirect("/jobs")
		refresh()
	}

	return (
		<Create
			mutationOptions={{ onSuccess }}
			title="resources.jobs.create"
		>
			<SimpleForm>
				<Box sx={sx.prose}>
					<TextInput
						label="resources.jobs.fields.name"
						source="name"
						validate={required()}
						fullWidth
					/>
				</Box>
			</SimpleForm>
		</Create>
	)
}

export default JobCreate
